export type ShellDocumentTheme = 'dark' | 'light'

export const DEV_SHELL_DOCUMENT_THEME_STORAGE_KEY = 'sigchatExpmgrDevShellDocumentTheme'

export function parseShellDocumentTheme(raw: string | null | undefined): ShellDocumentTheme | null {
  if (raw === 'dark' || raw === 'light') {
    return raw
  }
  return null
}

export function readStoredShellDocumentTheme(
  storage: Pick<Storage, 'getItem'> = sessionStorage,
): ShellDocumentTheme | null {
  try {
    return parseShellDocumentTheme(storage.getItem(DEV_SHELL_DOCUMENT_THEME_STORAGE_KEY))
  } catch {
    return null
  }
}

export function resolveShellDocumentTheme(
  locationSearch: string,
  matchMedia: Window['matchMedia'] | undefined = globalThis.matchMedia,
): ShellDocumentTheme {
  const urlTheme = new URLSearchParams(locationSearch).get('theme')
  const override = parseShellDocumentTheme(urlTheme)
  if (override) {
    return override
  }
  if (matchMedia?.('(prefers-color-scheme: dark)').matches) {
    return 'dark'
  }
  return 'light'
}

export function resolveInitialShellDocumentTheme(
  locationSearch: string,
  matchMedia: Window['matchMedia'] | undefined = globalThis.matchMedia,
  storage: Pick<Storage, 'getItem'> = sessionStorage,
): ShellDocumentTheme {
  const urlTheme = parseShellDocumentTheme(new URLSearchParams(locationSearch).get('theme'))
  if (urlTheme) {
    return urlTheme
  }
  const stored = readStoredShellDocumentTheme(storage)
  if (stored) {
    return stored
  }
  return resolveShellDocumentTheme(locationSearch, matchMedia)
}

export function readShellDocumentTheme(): ShellDocumentTheme {
  if (document.documentElement.classList.contains('light')) {
    return 'light'
  }
  return 'dark'
}

const SPLASH_BODY_CLASS = 'shell-document-body'

export function applyShellDocumentTheme(theme: ShellDocumentTheme): void {
  document.documentElement.classList.remove('dark', 'light')
  document.documentElement.classList.add(theme)
  document.body.classList.add(SPLASH_BODY_CLASS)
}

export function initializeShellDocumentTheme(): ShellDocumentTheme {
  const theme = resolveInitialShellDocumentTheme(globalThis.location.search)
  applyShellDocumentTheme(theme)
  return theme
}
